import { omit } from 'lodash'
import { useCallback, useState } from 'react'
import { useSelector } from 'react-redux'
import { inviteUser, updateSystemUser } from '../../../../../crud/users.crud'
import { COGNITO_MESSAGE_ACTIONS } from '../../../../../util/cognito.util'

const INVITED_USER_ROLE = 'read-only'

/**
 * Saves an existing system user the way Edit System User always has: the email never changes, and
 * adding the Augmentt password login resends the invite.
 */
const useUpdateSystemUser = ({ userId, onSaved }) => {
  const currentUser = useSelector(({ user }) => user.data)
  const [isSaving, setSaving] = useState(false)
  const [hasSaveError, setSaveError] = useState(false)

  const saveSystemUser = useCallback(
    async (data) => {
      setSaving(true)
      setSaveError(false)
      try {
        await updateSystemUser(currentUser.organization, userId, omit(data, ['email']))
      } catch (error) {
        console.error(error.message)
        setSaveError(true)
        setSaving(false)
        return
      }

      if (data.message_action === COGNITO_MESSAGE_ACTIONS.RESEND) {
        try {
          await inviteUser({ ...data, Customer: currentUser.Customer, role: INVITED_USER_ROLE })
        } catch (error) {
          // The user is already saved, so a failed invite does not keep the edit open.
          console.error(error.message)
        }
      }

      setSaving(false)
      onSaved?.()
    },
    [currentUser, userId, onSaved],
  )

  return { saveSystemUser, isSaving, hasSaveError }
}

export default useUpdateSystemUser
